import { Injectable } from '@angular/core';
import { isObject, isArray } from "lodash";
import { HelperService } from '../../util/helper/helper.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMiddlewareService {

  constructor(private helper: HelperService) { }

  filterFirebaseData(oldData, newData, conditions, matchKey, type) {
    let filteredData;
    if (!isArray(oldData) && !isArray(newData)) {
      filteredData = {};
      if (this.isObjectMatched(oldData, newData, conditions))
      filteredData = newData;
    } else if (isArray(oldData) && isArray(newData)) {
      filteredData = [];
      newData.map(item => {
        let oldObject = oldData.find(x => x[matchKey] === item[matchKey]);
        if(oldObject){
          if(this.isObjectMatched(oldObject, item, conditions)){
            oldObject = item;
            filteredData.push({...oldObject, type: 'replace'});
          }else{
            filteredData.push({...item, type: 'old'});
          }
        }else{
          filteredData.push({...item, type: 'new'});
        }
      })
      if(type === 'merge'){
        oldData.map(item => {
          const index = filteredData.findIndex(x=> x[matchKey] === item[matchKey]);
          if(index === -1){
            filteredData.push({...item, type: 'removed'});
          }
        })
      }
    }
    return filteredData;
  }

  isObjectMatched(oldObject, newObject, conditions) {
    if (!isArray(conditions))
      conditions = [conditions];

    const result = conditions.filter(item => {
      let oldData = this.getValue(oldObject, item.key);
      let newData = this.getValue(newObject, item.key);
      oldData = isObject(oldData) ? JSON.stringify(oldData) : oldData;
      newData = isObject(newData) ? JSON.stringify(newData) : newData;
      return this.condtion(item.operator, oldData, newData);
    })
    return result.length === conditions.length;
  }

  condtion(operator, val1, val2) {
    switch (operator) {
      case 'lt':
        return val1 < val2;
      case 'lte':
        return val1 <= val2;
      case 'gt':
        return val1 > val2;
      case 'gte':
        return val1 >= val2;
      case 'eq':
        return val1 === val2;
      case 'neq':
        return val1 !== val2;
    }
  }

  getValue(object, key) {
    return key
      .split('.')
      .reduce((o, k) => {
        const data = (typeof o === 'string' ? JSON.parse(o) : o)
        return data ? data[k] : o
      }, object)
  }
}
